import React from "react"
import SaveIcon from "@mui/icons-material/Save";
import {IconButton} from "../../../features/management-v2/import/inputs";
import {useCreateContactGroup} from "../hooks/useCreateContactGroup";
import {useGolemErrors} from "../../../lib/golem/useGolemErrors";
import {GolemText} from "../../../lib/golem/GolemField";

export function ContactGroupCreate() {
    const {name, setName, isLoading, submit} = useCreateContactGroup();
    const golemErrors = useGolemErrors();

    return (
        <div className="bg-white shadow-md p-4 flex flex-col gap-4">
            <h1 className="text-lg font-semibold">Create Contact Group</h1>
            <GolemText label="Name" value={name} onChange={setName} errors={golemErrors} field="name" required/>
            <IconButton text="Save" loading={isLoading} onClick={async () => {
                try { await submit(); } catch (e) { golemErrors.setFromAxiosError(e); }
            }} icon={<SaveIcon/>} color="green"/>
        </div>
    )
}
